import { render, staticRenderFns } from "./OtherTaxDisclaimer.vue?vue&type=template&id=c7c23082&"
import script from "./OtherTaxDisclaimer.vue?vue&type=script&lang=js&"
export * from "./OtherTaxDisclaimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports